module.exports = __webpack_public_path__ + "img/card.07225b80.png";